import React from "react";
import {Label, Input} from "reactstrap";
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import {useTranslation} from "react-i18next";

const InputField = (
    {
        schema,
        formData,
        onChange,
        required,
        disabled,
        uiSchema,
        idSchema,
    }
) => {
    const {t, i18n} = useTranslation();

    const description = t(schema.description) || uiSchema['ui:description'];
    const inputType = get(uiSchema, 'ui:options')?.inputType;
    const inputValue = get(schema, 'default') === formData ? t(get(schema, 'default')) : (formData || '');

    const change = (e) => {
        let value = e.target.value;
        if (inputType) {
            switch (inputType) {
                case 'number':
                    value = Number(value);
                    break;
            }
        }
        return onChange(value);
    }

    return <div className={get(uiSchema, 'ui:className')}>
        <Label className='control-label' for={get(idSchema, '$id')}>
            {t(schema.title)}
            {(schema.title && required) ? ' *' : ''}
        </Label>
        {
            !isEmpty(description) && <small className="form-text text-muted mb-3">
                {description}
            </small>
        }
        <Input
            type={inputType || 'text'}
            value={inputValue}
            placeholder={t(get(uiSchema, 'ui:placeholder'))}
            onChange={change}
            required={required}
            disabled={disabled}
            id={get(idSchema, '$id')}
            readOnly={get(uiSchema, 'ui:readonly')}
            label={t(schema.title)}
            maxLength={get(schema, 'maxLength')}
         />
    </div>
}

export default InputField;